import { render } from "./EnTab.vue?vue&type=template&id=c1f385d6"
import script from "./EnTab.vue?vue&type=script&setup=true&lang=js"
export * from "./EnTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/tabs/EnTab/EnTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1f385d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1f385d6', __exports__)) {
    api.reload('c1f385d6', __exports__)
  }
  
  module.hot.accept("./EnTab.vue?vue&type=template&id=c1f385d6", () => {
    api.rerender('c1f385d6', render)
  })

}


export default __exports__